import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Modal from '../../../Modal/Modal';
import SingleObjUploaderWithSelector from '../../Mam/SingleObjUploaderWithSelector';
import imageModifier from '../../../../utils/imageModifier';

import { redtktVoucherTranslations as translations } from './ItemsComponentsUtils/componentsTextTranslations';


const RedtktAccessButton = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'RedtktAccessButton',
    sourceWeb: '',
    isCentered: true,
    image: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    watchNowButtonText: {
      en: 'go to event',
      es: 'ir al evento',
      ca: 'anar a l\'esdeveniment',
      pt: 'go to event',
    },
    translations,
    postVideoUrl: '',
    postVideoRole: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isModalOn, setModalState] = useState(false);
  const [activeLang, setActiveLanguage] = useState('');
  const [visibleLangImage, setSelectedImage] = useState({
    en: '',
    es: '',
    ca: '',
    pt: '',
  });

  const inputHandler = (e) => {
    const { value, name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const inputHandlerByLanguage = (e, lang = 'en') => {
    const { component } = components[index];
    const { name = '', value = '' } = e.target;
    let comp;
    if (name === 'watchNowButtonText') {
      comp = {
        ...component,
        [name]: {
          ...component[name],
          [lang.toLowerCase()]: value,
        },
      };
    } else {
      comp = {
        ...component,
        translations: {
          ...component.translations,
          loggedModal: {
            ...component.translations.loggedModal,
            [name]: {
              ...component.translations.loggedModal[name],
              [lang.toLowerCase()]: value,
            },
          },
        },
      };
    }

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const toggleModal = (lang) => {
    setActiveLanguage(lang);
    setModalState(!isModalOn);
  };

  const setImage = ([obj]) => {
    const { component } = components[index];
    toggleModal();
    const newImage = {
      ...visibleLangImage,
      [activeLang]: obj.objectUrl,
    };
    setSelectedImage(newImage);
    const comp = {
      ...component,
      image: {
        ...component.image,
        [activeLang.toLowerCase()]: obj.url,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);
  return (
    <>
      <div className="w-full px-5 rounded-lg bg-greyFilter flex flex-col pt-4 pb-4">
        <div className="bg-greyFilter w-full sm:w-full md:w-full p-4 pl-9">
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black " htmlFor="text">
            <div className="">Watch now text</div>
            {languages.map(lang => (
              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} pb-6px w-full`}>
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black" htmlFor="title">
                  <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1  p-2" onChange={e => inputHandlerByLanguage(e, lang)} name="watchNowButtonText" lang={lang} type="text" value={state.watchNowButtonText[lang.toLowerCase()] || ''} readOnly={reusableComponent && reusableComponent} />
                </label>
              </div>
            ))}
          </label>
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black " htmlFor="text">
            <div className="">Voucher Title</div>
            {languages.map(lang => (

              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} pb-6px w-full`}>
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black" htmlFor="title">
                  <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1  p-2" onChange={e => inputHandlerByLanguage(e, lang)} name="voucherTitle" lang={lang} type="text" value={state.translations.loggedModal.voucherTitle[lang.toLowerCase()] || ''} readOnly={reusableComponent && reusableComponent} />
                </label>
              </div>
            ))}
          </label>
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black " htmlFor="text">
            <div className="">Voucher Description</div>
            {languages.map(lang => (
              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} pb-6px w-full`}>
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black" htmlFor="title">
                  <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1  p-2" onChange={e => inputHandlerByLanguage(e, lang)} name="voucherDescription" lang={lang} type="text" value={state.translations.loggedModal.voucherDescription[lang.toLowerCase()] || ''} readOnly={reusableComponent && reusableComponent} />
                </label>
              </div>
            ))}
          </label>
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black " htmlFor="text">
            <div className="">Voucher Link</div>
            {languages.map(lang => (
              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} pb-6px w-full`}>
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black" htmlFor="title">
                  <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1  p-2" onChange={e => inputHandlerByLanguage(e, lang)} name="getVoucherLink" lang={lang} type="text" value={state.translations.loggedModal.getVoucherLink[lang.toLowerCase()] || ''} readOnly={reusableComponent && reusableComponent} />
                </label>
              </div>
            ))}
          </label>
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black " htmlFor="text">
            <div className="">Voucher Conditions</div>
            {languages.map(lang => (

              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} pb-6px w-full`}>
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black" htmlFor="title">
                  <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1  p-2" onChange={e => inputHandlerByLanguage(e, lang)} name="voucherConditions" lang={lang} type="text" value={state.translations.loggedModal.voucherConditions[lang.toLowerCase()] || ''} readOnly={reusableComponent && reusableComponent} />
                </label>
              </div>
            ))}
          </label>
        </div>
        <div className="pl-9 w-full">
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="role">
              Source Web
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="sourceWeb" type="text" value={(state && state.sourceWeb) || ''} />
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="role">
              Final Video Role
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="postVideoRole" type="text" value={(state && state.postVideoRole) || ''} />
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="url">
              Final Video Url (without https://primaverasound.com)
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="postVideoUrl" type="text" value={(state && state.postVideoUrl) || ''} />
            </label>
          </div>
        </div>
        <div className={`xxl1:w-1/4 px-2 xxl1:ml-2 -mt-4 flex items-center flex-col ${state && state.image && state.image[activeLanguage] ? 'justify-evenly' : 'justify-center'}`}>
          <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-black text-white mt-4 whitespace-pre" type="button" onClick={() => toggleModal(activeLanguage)}>
            Select image
          </button>
          <div className="image">{state && state.image && state.image[activeLanguage] ? !state.image[activeLanguage].includes('svg') ? <img src={imageModifier(state.image[activeLanguage], '100x100')} /> : <img src={state.image[activeLanguage]} height="100" width="100" /> : null}</div>
        </div>
      </div>
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle>
          <SingleObjUploaderWithSelector selectCallback={setImage} />
        </Modal>
      )}
    </>
  );
};

RedtktAccessButton.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
RedtktAccessButton.defaultProps = {
  reusableComponent: null,
};

export default RedtktAccessButton;
